import { Fragment } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'
import { TermPrivacyLayout } from '@/components/Layout/TermsAndPrivacy'

import { renderTemplate } from '@/features/term-privacy/utils'

import { REFERRAL_TERMS } from '../constants/referralTerms'

function ReferralTerms(): React.ReactElement {
  return (
    <Fragment>
      <NextSeo title="ข้อกำหนดและเงื่อนไขกิจกรรมการแนะนำผู้ซื้อรายใหม่" />

      <TermPrivacyLayout menus={[REFERRAL_TERMS]}>
        <h1>ข้อกำหนดและเงื่อนไขกิจกรรมการแนะนำผู้ซื้อรายใหม่</h1>
        <p>
          ข้อกำหนดและเงื่อนไขในกิจกรรมแนะนำผู้ซื้อรายใหม่ฉบับนี้
          (&quot;ข้อกำหนดและเงื่อนไข&quot;)
          ได้ระบุถึงข้อกำหนดและเงื่อนไขในการเข้าร่วมกิจกรรมแนะนำผู้ซื้อรายใหม่ของบริษัท
          โดยมีชื่อกิจกรรมว่า &quot;PDPA Pro Referral Program&quot;
          (&quot;กิจกรรมการแนะนำ&quot;) ที่จัดขึ้นโดย บริษัท เอ็นเดต้าธอธ จำกัด
          (&quot;บริษัท&quot; หรือ &quot;เรา&quot;) เพื่อให้ผู้แนะนำ
          (โดยจะเรียกว่า &quot;ผู้แนะนำ&quot; หรือ &quot;ท่าน&quot;
          ขึ้นอยู่กับเนื้อหา)
          รับทราบและเข้าใจถึงข้อกำหนดและเงื่อนไขสำหรับการเข้าร่วมกิจกรรมดังกล่าว
        </p>

        {renderTemplate(REFERRAL_TERMS.subMenus)}

        <div id="endTermsContent" css={{ marginTop: 48 }}>
          เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อวันที่ 25 มกราคม พ.ศ. 2565
        </div>
      </TermPrivacyLayout>
    </Fragment>
  )
}

export default withPage()(ReferralTerms)
